import { useMutation } from '@tanstack/react-query'
import { postMigrateUser } from '../../infrastructure/api-signup'
import { useUIContext } from '../../context/UIContext'
import { useNavigate } from 'react-router-dom'

export const useMigrateUser = () => {
    const navigate = useNavigate()
    const { showError } = useUIContext()
    const {
        mutate: migrate,
        isPending: isMigrating,
        ...rest
    } = useMutation({
        mutationFn: async (...params: Parameters<typeof postMigrateUser>) => postMigrateUser(...params),
        onError: error => showError(error.message),
        onSettled: () => navigate('/'),
    })

    return {
        migrate,
        isMigrating,
        ...rest,
    }
}
